import configuracionServices from '../services/Configuracion'
import formValidation from '../validations/FormValidation';

const tableroLogic = async (idTablero, page, perPage, search = "") => {
  let dataResp = configuracionServices.tableroService(idTablero, page, perPage, search)
  return dataResp
}

const saveEditTableroLogic = async (idTablero, data, saveType) => {
  let dataResp;
  if (saveType === "D") {
    const daraToSave = {
      idTablero: idTablero.id,
      nombreTablero: idTablero.Nombre,
      descripcion: idTablero.Descripcion,
      urlReporte: '',
      esActivo: 'N',
      listArea: {},
      usuarioActualizacion: localStorage.getItem('userName')
    };
    dataResp = configuracionServices.saveEditTableroService(daraToSave);

  } else {

    const validation = formValidation.FormValidatiopn(data, 'E');
    dataResp = validation;
    if (!validation.error) {
      const daraToSave = {
        idTablero,
        nombreTablero: data.name.value,
        descripcion: data.description.value,
        urlReporte: data.url.value,
        //idReporte: data.idReporte.value,
        //idDataset: data.idDataset.value,
        esActivo: 'S',
        listArea: (data.area && data.area.value) ? {
          idArea: data.area.value,
          esActivoArea: 'S'
        } : {}
      };

      if (saveType === 'I') {
        daraToSave.usuarioCreacion = localStorage.getItem('userName');
      } else if (saveType === 'U') {
        daraToSave.usuarioActualizacion = localStorage.getItem('userName');
      }

      dataResp = configuracionServices.saveEditTableroService(daraToSave);
    }
  }


  return dataResp;
};

const saveEditAreaLogic = async (idArea, data, saveType, selectedTableros, idsAEliminar) => {
  let dataResp;
  let daraToSave;
  if (saveType === "D") {
    daraToSave = {
      idArea: idArea.id,
      nombreArea: idArea.Nombre,
      descripcion: idArea.Descripcion,
      idReporte: idArea.Id,
      esActivo: 'N',
      listTablero: selectedTableros
    }
    daraToSave.usuarioActualizacion = localStorage.getItem('userName')
    dataResp = configuracionServices.saveEditAreaService(daraToSave);
  } else {
    const validation = idsAEliminar.length === 0 ? formValidation.FormValidatiopn(data, 'E') : { error: false };
    dataResp = validation;

    if (!validation.error) {
      daraToSave = {
        idArea,
        nombreArea: data.name.value,
        descripcion: data.description.value,
        idReporte: data.idCode.value,
        esActivo: 'S',
        listTablero: idsAEliminar
      }

      for (let i = 0; i < selectedTableros.length; i++) {
        daraToSave.listTablero.push({
          idTablero: selectedTableros[i].value,
          esActivoTablero: 'S'
        });
      }

      if (saveType === 'I') {
        daraToSave.usuarioCreacion = localStorage.getItem('userName')
      } else if (saveType === 'U') {
        daraToSave.usuarioActualizacion = localStorage.getItem('userName')
      }
      dataResp = configuracionServices.saveEditAreaService(daraToSave);
    }
  }

  return dataResp;
}

const areasLogic = async (idArea, page, perPage, search = "") => {
  let dataResp = configuracionServices.areasService(idArea, page, perPage, search)
  return dataResp
}

const areasLogicBi = async (idArea, page, perPage, search = "") => {
  let dataResp = configuracionServices.areasBiService(idArea, page, perPage, search)
  return dataResp
}

const tabRoleUserLogic = async (idTablero) => {
  let dataResp = configuracionServices.tabRoleUserService(idTablero)
  return dataResp
}

const saveTabRoleUserLogic = async (idTablero, nombreTablero, listRoles, listUsuario) => {
  const daraToSave = {
    idTablero,
    nombreTablero: nombreTablero,
    listRoles,
    listUsuario,
    usuarioActualizacion: localStorage.getItem('userName')
  }
  let dataResp = configuracionServices.saveTabRoleUserService(daraToSave)
  return dataResp
}

const areasNewLogicBi = async (idArea, page, perPage, search = "") => {
  let dataResp = configuracionServices.areasNewBiService(idArea, page, perPage, search)
  return dataResp
}

const tableroXAreasBiLogic = async (idArea, page, perPage, search = "") => {
  let dataResp = configuracionServices.tableroXAreasBiService(idArea, page, perPage, search)
  return dataResp
}

const empresasLogic = async (idEmpresa, page, perPage, search = "") => {
  let dataResp = configuracionServices.empresasService(idEmpresa, page, perPage, search)
  return dataResp
}

const saveEditEmpresaLogic = async (idEmpresa, data, saveType) => {
  let dataResp;
  if (saveType === "D") {
    const daraToSave = {
      idEmpresa,
      nombreEmpresa: data.Nombre,
      codigoTipoIdentificacion: data.Siglas,
      numeroIdentificacion: data.Identificación,
      ruc: '1234567890987',
      direccion: data.Dirección,
      siglasEmpresa: data.Siglas,
      nombreRepresentanteLegal: data.Representante,
      esActivo: 'N',
      objGrupo: [],
      usuarioActualizacion: localStorage.getItem('userName')
    }


    dataResp = configuracionServices.saveEditEmpresaService(daraToSave);

  } else {
    const validation = formValidation.FormValidatiopn(data, 'E');
    dataResp = validation;
    if (!validation.error) {
      const obGroup = {
        idGrupo: data.grupo.value
      }
      const daraToSave = {
        idEmpresa,
        nombreEmpresa: data.nombre.value,
        codigoTipoIdentificacion: data.estb.value,
        numeroIdentificacion: data.identificacion.value,
        ruc: data.ruc.value,
        direccion: data.direccion.value,
        siglasEmpresa: data.siglas.value,
        nombreRepresentanteLegal: data.representante.value,
        esActivo: 'S',
        objGrupo: obGroup
      }

      if (saveType === 'I') {
        daraToSave.usuarioCreacion = localStorage.getItem('userName')
      } else if (saveType === 'U') {
        daraToSave.usuarioActualizacion = localStorage.getItem('userName')
      }

      dataResp = configuracionServices.saveEditEmpresaService(daraToSave);
    }
  }

  return dataResp;
}

const usuariosConfigLogic = async (idUsuarioConfig, page, perPage, search = "", tipoUsuario) => {
  let dataResp = configuracionServices.usuariosConfigService(idUsuarioConfig, page, perPage, search, tipoUsuario)
  return dataResp
}

const usuariosaConfigEditEmpresaLogic = async (idUsuario, data, saveType) => {
  const validation = formValidation.FormValidatiopn(data, 'E');
  let dataResp = validation;

  if (!validation.error) {
    const daraToSave = {
      secuenciaPersonal: idUsuario,
      codigoTipoIdentificacion: 2,
      numeroIdentificacion: data.identificacion.value,
      primerNombre: data.pNombre.value,
      segundoNombre: data.sNombre.value,
      primerApellido: data.pApellido.value,
      segundoApellido: data.sApellido.value,
      codigoUsuario: data.codigo.value,
      contrasenia: '',
      email: data.email.value,
      sexo: data.sexo.value,
      fechaDeNacimiento: data.fNacimiento.value,
      idEmpresa: data.empresa.value,
      esActivo: data.estado.value,
    }

    if (saveType === 'I') {
      daraToSave.usuarioCreacion = localStorage.getItem('userName')
    } else if (saveType === 'U') {
      daraToSave.usuarioActualizacion = localStorage.getItem('userName')
    }

    dataResp = configuracionServices.saveEditUsuariosConfigService(daraToSave);
  }

  return dataResp;
}

const usuariosSeguridadesBiLogic = async (idUsuario, data, saveType) => {
  let dataResp;
  if (saveType === "D") {
    const daraToSave = {
      secuenciaPersonal: idUsuario,
      codigoTipoIdentificacion: 2,
      numeroIdentificacion: data.Identificación,
      primerNombre: data.Nombre,
      segundoNombre: data.Nombre,
      primerApellido: data.Nombre,
      segundoApellido: data.Nombre,
      codigoUsuario: data.Código,
      contrasenia: '',
      email: data.Email,
      sexo: '',
      fechaDeNacimiento: '',
      idEmpresa: data.idEmpresa,
      esActivo: "N",
      usuarioActualizacion: localStorage.getItem('userName'),
    }

    dataResp = configuracionServices.saveEditUsuariosConfigService(daraToSave, saveType);

  } else {

    const validation = formValidation.FormValidatiopn(data, 'E');
    dataResp = validation;
    let rolUser = '';
    let codeUser = '';
    if (!validation.error) {
      rolUser = data.empresa.value;
      codeUser = data.codigo.value;
      const daraToSave = {
        secuenciaPersonal: idUsuario,
        codigoTipoIdentificacion: 2,
        numeroIdentificacion: data.identificacion.value,
        primerNombre: data.pNombre.value,
        segundoNombre: data.sNombre.value,
        primerApellido: data.pApellido.value,
        segundoApellido: data.sApellido.value,
        codigoUsuario: data.codigo.value,
        contrasenia: '',
        email: data.email.value,
        sexo: data.sexo.value,
        fechaDeNacimiento: data.fNacimiento.value,
        idEmpresa: data.empresa.value,
        esActivo: data.estado.value,
        rol: data.rol.value
      }

      if (saveType === 'I') {
        daraToSave.usuarioCreacion = localStorage.getItem('userName')
      } else if (saveType === 'U') {
        daraToSave.usuarioActualizacion = localStorage.getItem('userName')
      }

      dataResp = configuracionServices.saveEditUsuariosConfigService(daraToSave, saveType);
    }
  }

  return dataResp;
}

const grupoLogic = async (idGrupo, page, perPage, search = "") => {
  let dataResp = configuracionServices.grupoService(idGrupo, page, perPage, search)
  return dataResp
}

const saveEditGroupLogic = async (idGrupoEmpresa, data, saveType) => {
  let dataResp;
  if (saveType === "D") {
    const daraToSave = {
      idGrupoEmpresa,
      nombreGrupo: data.Nombre,
      descripcionGrupo: data.Descripción,
      esActivo: "N",
      usuarioActualizacion: localStorage.getItem('userName')
    }

    dataResp = configuracionServices.saveEditGroupService(daraToSave);

  } else {
    const validation = formValidation.FormValidatiopn(data, 'E');
    dataResp = validation;

    if (!validation.error) {
      const daraToSave = {
        idGrupoEmpresa,
        nombreGrupo: data.nombre.value,
        descripcionGrupo: data.descripcion.value,
        esActivo: data.estado.value
      }

      if (saveType === 'I') {
        daraToSave.usuarioCreacion = localStorage.getItem('userName')
      } else if (saveType === 'U') {
        daraToSave.usuarioActualizacion = localStorage.getItem('userName')
      }

      dataResp = configuracionServices.saveEditGroupService(daraToSave);
    }
  }
  return dataResp;
}

const getTokenBI = async (idDataset, idReporte) => {
  let dataResp = configuracionServices.getTokenBI(idDataset, idReporte)
  return dataResp
}

const configuracionLogic = {
  tableroLogic,
  areasLogic,
  saveEditTableroLogic,
  saveEditAreaLogic,
  areasLogicBi,
  tabRoleUserLogic,
  saveTabRoleUserLogic,
  areasNewLogicBi,
  tableroXAreasBiLogic,
  empresasLogic,
  saveEditEmpresaLogic,
  usuariosConfigLogic,
  usuariosaConfigEditEmpresaLogic,
  grupoLogic,
  saveEditGroupLogic,
  usuariosSeguridadesBiLogic,
  getTokenBI
}

export default configuracionLogic
